var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#DEDDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7215 14.1065C18.6846 13.7492 18.646 13.3785 18.5513 13.0086C18.2932 12.1236 17.5783 11.5714 16.8117 11.5714C16.3841 11.5698 15.8433 11.8333 15.5367 12.0999L12.9952 14.2288H11.6647C10.6855 14.2288 9.89817 14.9836 9.74948 16.0729C9.62313 17.1188 9.59232 19.0931 9.74948 20.2439C9.88584 21.3947 10.6377 22.1385 11.6647 22.1385H12.9952L15.586 24.299C15.8518 24.5301 16.321 24.7951 16.7524 24.7951C16.7801 24.7959 16.8048 24.7959 16.8294 24.7959C17.6106 24.7959 18.2986 24.2232 18.5567 23.3406C18.6545 22.9652 18.6884 22.6134 18.7215 22.2734L18.7562 21.9366C18.8887 20.8442 18.8887 15.516 18.7562 14.4315L18.7215 14.1065Z",
    fill: "#5C58FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.6967 14.1389C21.4848 13.8265 21.065 13.7484 20.7576 13.9654C20.4533 14.1838 20.3778 14.6145 20.5896 14.9261C21.179 15.7945 21.5033 16.9508 21.5033 18.1837C21.5033 19.4157 21.179 20.5729 20.5896 21.4413C20.3778 21.7529 20.4533 22.1835 20.7583 22.402C20.8724 22.4825 21.0056 22.5251 21.1428 22.5251C21.3639 22.5251 21.5703 22.4138 21.6967 22.2285C22.4409 21.1321 22.8515 19.6957 22.8515 18.1837C22.8515 16.6716 22.4409 15.2353 21.6967 14.1389Z",
    fill: "#5C58FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.0188 11.9074C23.8085 11.5958 23.3871 11.5161 23.0804 11.7338C22.7761 11.9523 22.7006 12.383 22.9117 12.6945C23.9086 14.1632 24.4579 16.1131 24.4579 18.1836C24.4579 20.2549 23.9086 22.2047 22.9117 23.6734C22.7006 23.9858 22.7761 24.4156 23.0812 24.6341C23.1952 24.7146 23.3277 24.7572 23.4649 24.7572C23.686 24.7572 23.8932 24.6459 24.0188 24.4606C25.1713 22.764 25.8061 20.5349 25.8061 18.1836C25.8061 15.8338 25.1713 13.604 24.0188 11.9074Z",
    fill: "#5C58FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOn);
export default __webpack_public_path__ + "static/media/sound_on.0f8b6dae3dc15eec65dbd984c5f7b5d9.svg";
export { ForwardRef as ReactComponent };